// extracted by mini-css-extract-plugin
export default {"container":"root_container__CpyEt"};